import { buildFormSchema } from '@/utils/validation/formSchemaKit';
import {
  buildCommonValidationMessages,
  emailField,
  passwordConfirmField,
  passwordField,
  refinePasswordsMatch,
  requiredString,
} from '@/utils/validation/schemaHelpers';

import type { FormSchema } from '@/utils/validation/formSchemaKit';
import type { TFunction } from 'i18next';

export const buildLoginFormSchema = (t: TFunction): FormSchema => {
  const messages = buildCommonValidationMessages(t);
  return buildFormSchema({
    email: emailField(messages),
    password: requiredString(messages.required),
  });
};

export const buildResetPasswordRequestFormSchema = (
  t: TFunction,
): FormSchema => {
  const messages = buildCommonValidationMessages(t);
  return buildFormSchema({
    email: emailField(messages),
  });
};

export const buildResetPasswordConfirmFormSchema = (
  t: TFunction,
): FormSchema => {
  const messages = buildCommonValidationMessages(t);
  return buildFormSchema(
    {
      uid: requiredString(messages.required),
      token: requiredString(messages.required),
      new_password: passwordField(messages),
      new_password_confirm: passwordConfirmField(messages),
    },
    (schema) =>
      refinePasswordsMatch(
        schema,
        'new_password',
        'new_password_confirm',
        messages.passwordMismatch,
      ),
  );
};

export const buildMfaFormSchema = (t: TFunction): FormSchema => {
  const messages = buildCommonValidationMessages(t);
  return buildFormSchema({
    otp_token: requiredString(messages.required),
  });
};

export const buildPasswordInvitationFormSchema = (t: TFunction): FormSchema => {
  const messages = buildCommonValidationMessages(t);
  return buildFormSchema(
    {
      password: passwordField(messages),
      password_confirm: passwordConfirmField(messages),
    },
    (schema) =>
      refinePasswordsMatch(
        schema,
        'password',
        'password_confirm',
        messages.passwordMismatch,
      ),
  );
};
